import { RType } from "types/vehicles";

interface ServerSentResponse {
    type: "group" | "vehicle" | "incident";
    center: string;
    rt: RType;
    cnt?: number;
    id?: number;
    course?: number;
    on: boolean;
    date?: string;
    depot_number?: number;
    speed_avg?: number;
    device_id?: string;
    login?: string;
    alarm_triggered?: boolean;
    alarm_center?: string;
    alarm_date?: string;
}

interface IResponse {
    incident_type: number;
    type: "group" | "incident";
    center: string;
    cnt?: number;
}

export const parseTransportCoords = (response: Array<ServerSentResponse>, type?: string) => {
    return response.map((cluster) => {
        const amounts: { [key: string]: number } = {};
        let id = undefined;
        let course = undefined;
        
        amounts[cluster.rt] = cluster.cnt!;

        if (cluster.type === 'vehicle') {
            id = cluster.id;
            course = cluster.course
        }
        const {
            date,
            depot_number,
            speed_avg,
            login,
            alarm_triggered,
            alarm_center,
            alarm_date,
        } = cluster;
        return {
            coords: (cluster.center).slice(6, -1).split(" ").map(coord => parseFloat(coord)),
            size: cluster.type === "group" ? cluster.cnt! : 1,
            parts:           amounts,
            on:              cluster.on,
            course,
            id,
            date,
            depot_number,
            speed_avg,
            device_id:       cluster?.device_id,
            login,
            alarm_triggered,
            alarm_date,
            ab_coords:       (alarm_center || '').slice(6, -1).split(" ").map(coord => parseFloat(coord)),
            ...(type ? {type: type} : {})
        };
    });
};

export const parseIncidentsCoords = (response: Array<IResponse>) => {
    return response.map((cluster) => ({
        coords: (cluster.center).slice(6, -1).split(" ").map(coord => parseFloat(coord)),
        size: cluster.type === 'group' ? cluster.cnt! : 1,
        incident_type: cluster.incident_type
    }));
};